export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F110F] text-[#EFECE7]/70 py-14">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center">
            <span className="font-serif-display text-xl text-white">Dott. Manuel Gotti</span>
          </div>
          <p className="text-xs mt-4 leading-relaxed max-w-xs">
            Ematologo · Iscritto all&apos;Ordine dei Medici della Provincia di Pavia.
            Riceve presso Fondazione IRCCS Policlinico San Matteo e Studio Viqueria (Voghera).
          </p>
        </div>

        <div>
          <p className="eyebrow text-[#EFECE7]/50">Sezioni</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="#chi-sono" className="hover:text-white transition-colors">Chi Sono</a></li>
            <li><a href="#patologie" className="hover:text-white transition-colors">Patologie trattate</a></li>
            <li><a href="#seconda-opinione" className="hover:text-white transition-colors">Seconda opinione</a></li>
            <li><a href="#ricerca" className="hover:text-white transition-colors">Ricerca</a></li>
            <li><a href="#sedi" className="hover:text-white transition-colors">Sedi</a></li>
            <li><a href="#prenota" className="hover:text-white transition-colors">Prenota</a></li>
            <li><a href="#educazione" className="hover:text-white transition-colors">Educazione</a></li>
            <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
          </ul>
        </div>

        <div>
          <p className="eyebrow text-[#EFECE7]/50">Legale</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>Informativa Privacy · Reg. UE 2016/679</li>
            <li>Cookie Policy</li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 mt-12 pt-6 border-t border-[#EFECE7]/10 text-xs flex flex-wrap gap-4 justify-between">
        <p>© {new Date().getFullYear()} Dott. Manuel Gotti — Tutti i diritti riservati.</p>
        <p>Sito informativo · Non sostituisce il parere medico.</p>
      </div>
    </footer>
  );
}
